function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.068 1.131a5.937 5.937 0 105.937 5.937 5.937 5.937 0 00-5.937-5.937M0 7.068a7.068 7.068 0 1112.447 4.585l3.219 3.213a.566.566 0 11-.8.8l-3.221-3.214A7.068 7.068 0 01-.001 7.067",
  fillRule: "evenodd"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.832 15.832",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgSearch;